import { Component, inject, Input, OnInit } from '@angular/core';
import { PermissionService } from '../../../../core/services/permission';
import { JobsFeatureAccessService } from '../../jobs.feature-access.service';
import { QuoteRequestListModel } from '../../../quoterequests/quoterequest-list/domain/entities/quote-request-list.model';
import { Job } from '../../../../data/models';

@Component({
    selector: 'app-job-quoterequests',
    templateUrl: './job-quoterequests.component.html',
    standalone: false,
})
export class JobQuoteRequestsComponent implements OnInit {
    // Set by route resolve
    // @ts-ignore TS2564
    @Input() job: Job;
    quoteRequestsCount: number = 0;

    modulePermitted: boolean = false;

    #jobFeatureAccessService = inject(JobsFeatureAccessService);
    permissionService = inject(PermissionService);

    ngOnInit() {
        this.modulePermitted = this.#jobFeatureAccessService.canAccessJobQuoteRequests();
    }

    onRequestsLoaded(e: QuoteRequestListModel[]) {
        this.quoteRequestsCount = e.length;
    }
}
